/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectFieldSettingsControllerFindForScopeQueryResponse, ProjectFieldSettingsControllerFindForScopePathParams, ProjectFieldSettingsControllerFindForScope401, ProjectFieldSettingsControllerFindForScope403 } from "../../models/projectFieldSettingsController/ProjectFieldSettingsControllerFindForScope";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectFieldSettingsControllerFindForScope } from "../../clients/project-field-settingsService/projectFieldSettingsControllerFindForScope";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectFieldSettingsControllerFindForScopeQueryKey = (scopeId: ProjectFieldSettingsControllerFindForScopePathParams["scopeId"]) => [{
  url: '/api/v1/scopes/:scopeId/project-field-settings',
  params: {
    scopeId: scopeId
  }
}] as const;
export type ProjectFieldSettingsControllerFindForScopeQueryKey = ReturnType<typeof projectFieldSettingsControllerFindForScopeQueryKey>;
export function projectFieldSettingsControllerFindForScopeQueryOptions(scopeId: ProjectFieldSettingsControllerFindForScopePathParams["scopeId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectFieldSettingsControllerFindForScopeQueryKey(scopeId);
  return queryOptions<ProjectFieldSettingsControllerFindForScopeQueryResponse, ResponseErrorConfig<ProjectFieldSettingsControllerFindForScope401 | ProjectFieldSettingsControllerFindForScope403>, ProjectFieldSettingsControllerFindForScopeQueryResponse, typeof queryKey>({
    enabled: !!scopeId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectFieldSettingsControllerFindForScope(scopeId, config);
    }
  });
}

/**
 * @summary Get the resolved project field settings
 * {@link /api/v1/scopes/:scopeId/project-field-settings}
 */
export function useProjectFieldSettingsControllerFindForScope<TData = ProjectFieldSettingsControllerFindForScopeQueryResponse, TQueryData = ProjectFieldSettingsControllerFindForScopeQueryResponse, TQueryKey extends QueryKey = ProjectFieldSettingsControllerFindForScopeQueryKey>(scopeId: ProjectFieldSettingsControllerFindForScopePathParams["scopeId"], options: {
  query?: Partial<QueryObserverOptions<ProjectFieldSettingsControllerFindForScopeQueryResponse, ResponseErrorConfig<ProjectFieldSettingsControllerFindForScope401 | ProjectFieldSettingsControllerFindForScope403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectFieldSettingsControllerFindForScopeQueryKey(scopeId);
  const query = useQuery({
    ...projectFieldSettingsControllerFindForScopeQueryOptions(scopeId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectFieldSettingsControllerFindForScope401 | ProjectFieldSettingsControllerFindForScope403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}